import React, { useMemo } from 'react';
import styled from 'styled-components';
import { AppSideBar } from '@ubeya/shared-web/components';
import { ReactComponent as LogoIcon } from '@ubeya/shared-web/assets/SidebarIcons/Logo/logo-default.svg';
import { ReactComponent as UsersIcon } from '@ubeya/shared-web/assets/SidebarIcons/Modules/workers-white.svg';
import { ReactComponent as MobileIcon } from '@ubeya/shared-web/assets/employee.svg';
import { ReactComponent as AccountsIcon } from '@ubeya/shared-web/assets/SidebarIcons/Modules/sidebar-suppliers.svg';
import { ReactComponent as BaseDollarIcon } from '@ubeya/shared-web/assets/payroll-dollar.svg';
import { ReactComponent as BillingHistoryIcon } from '@ubeya/shared-web/assets/compliance.svg';
import { ReactComponent as OperationsIcon } from '@ubeya/shared-web/assets/BookingBoard/warning.svg';
import { ReactComponent as CustomerSuccessIcon } from '@ubeya/shared-web/assets/SidebarIcons/Modules/sidebar-communication.svg';
import { ReactComponent as SettingsIcon } from '@ubeya/shared-web/assets/SidebarIcons/Modules/sidebar-settings.svg';
// import { ReactComponent as ReportsIcon } from '@ubeya/shared-web/assets/reports.svg';
import useCanAccessInvoicing from '../../shared/hooks/useCanAccessInvoicing';
import Profile from './Profile';

const DollarIcon = styled(BaseDollarIcon)`
  path {
    fill: ${({ theme }) => theme.colors.white};
  }
`;

const WhiteMobileIcon = styled(MobileIcon)`
  path {
    stroke: ${({ theme }) => theme.colors.white};
  }
`;

const SideBar = () => {
  const canAccessInvoicing = useCanAccessInvoicing();

  const links = useMemo(
    () => [
      [{ label: 'dashboard', to: '/dashboard', icon: LogoIcon, mainIcon: true }],
      [
        { label: 'accounts', to: '/accounts', icon: AccountsIcon },
        // { label: 'logos', to: '/logos', icon: AccountsIcon },
        { label: 'admins', to: '/admins', icon: UsersIcon },
        { label: 'appUsers', to: '/appUsers', icon: WhiteMobileIcon },
        // { label: 'b2bClients', to: '/b2bClients', icon: BriefcaseIcon },
        // { label: 'reports', to: '/reports', icon: ReportsIcon },
        { label: 'billing', to: '/billing', icon: DollarIcon },
        ...(canAccessInvoicing ? [{ label: 'invoicing', to: '/invoicing', icon: DollarIcon }] : []),
        { label: 'billingHistory', to: '/billingHistory', icon: BillingHistoryIcon },
        { label: 'operations', to: '/operations', icon: OperationsIcon },
        { label: 'customerSuccess', to: '/customer-success', icon: CustomerSuccessIcon },
        { label: 'smartCustomFeatures', to: '/customFeatures', icon: SettingsIcon }
      ]
    ],
    [canAccessInvoicing]
  );

  return (
    <AppSideBar links={links} shouldChangePageTitle={false}>
      <Profile />
    </AppSideBar>
  );
};

export default SideBar;
